import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../../i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../../core'
import MasterInit from './MasterInit'

const App = () => {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <I18nProvider>
                <LayoutProvider>
                    <Outlet />
                    <MasterInit />
                </LayoutProvider>
            </I18nProvider>
        </Suspense>
    )
}

export default App
